import { ModalController } from "../../../components/modal/controller.js";

export class UserPrivateAuthView {
  showLoginInHeader() {
    document.getElementById('header-menu').innerHTML = `
    <a href="javascript:app.userPrivateController.auth.showLogin()">
      <span class="material-symbols-sharp">login</span>
      Ingresar
    </a>
    `;
  }

  showLogin() {
    return new ModalController('Acceda a su cuenta', `
      <div style="border-right: 1px solid white;padding-right: 20px;display:grid">
        <h2>Email</h2>
        <input type="text" id="login-email" value="" placeholder="Ingrese su correo electrónico" />
        <h2>Contraseña</h2>
        <div class="login-password">
          <input type="password" id="login-pass" value="" placeholder="Ingrese su contraseña" />
          <div class="ojo oculto" onclick="app.userPrivateController.auth.loginPasswordVisibility(this)"></div>
        </div>
        <button onclick="app.userPrivateController.auth.login()">Ingresar</button>
        <div id="login-status" class="login-status">&nbsp;</div>
        <a href="javascript:app.userPrivateController.auth.showRecover()">Recuperar mi contraseña</a>
      </div>
      <div style="display: grid; color: white; font-size: 16px;padding-left:20px; align-items:start; align-content:center;">
        <button onclick="javascript:app.userPrivateController.auth.showRegister()">Registrarme</button>
        <!--
        <p>
          ...o también puede registrarse e ingresar con su cuenta de Google.
        </p>
        <button onclick="javascript:app.userPrivateController.auth.showGoogleLogin()" class="icono-google">Iniciar con Google</button>
        -->
      </div>
      `, 'login');
  }

  showRecover() {
    return new ModalController('Recuperar contraseña', `
      <div style="border-right: 1px solid white;padding-right: 20px;display:grid">
        <h2>Email</h2>
        <input type="text" id="recover-email" value="" placeholder="Ingrese su correo electrónico" />
        <button onclick="app.userPrivateController.auth.recover()">Recuperar</button>
        <div id="recover-status" class="recover-status">&nbsp;</div>
        <a href="javascript:app.userPrivateController.auth.showLogin()">Ingresar con mi correo electrónico</a>
      </div>
      <div style="display: grid; color: white; font-size: 16px;padding-left:20px; align-items:start; align-content:center;">
        <button onclick="javascript:app.userPrivateController.auth.showRegister()">Registrarme</button>
        <!--
        <p>
          ...o también puede registrarse e ingresar con su cuenta de Google.
        </p>
        <button onclick="javascript:app.userPrivateController.auth.showGoogleLogin()" class="icono-google">Iniciar con Google</button>
        -->
      </div>
      `, 'login recover');
  }

  renderRegister() {
    return `
        <div class="form">
          <h2 class="mb0 ancho">Datos de acceso</h2>
            <div class="group">
              <div class="group">
                <b>Email</b>
                <input type="email" id="register-email" value=""> 
                <span id="register-email-error"></span>
              </div>
              <div class="group">
                <b>Contraseña</b>
                <input type="password" id="register-pass" value=""> 
                <span id="register-password-error"></span>
              </div>
              <div class="group">
                <b>Confirme su contraseña</b>
                <input type="password" id="register-re-pass" value="" placeholder=""> 
                <span id="register-re-pass-error"></span>
              </div>
            </div>
            <div class="group">
              <!--
              <p>
                ...o también puede registrarse e ingresar con su cuenta de Google.
              </p>
              <button onclick="javascript:app.userPrivateController.auth.showGoogleLogin()" class="icono-google">Iniciar con Google</button>
              -->
            </div>
          <h2 class="mb0 ancho">Datos personales</h2>
          <div class="group">
            <b>Nombre</b>
            <input type="text" id="register-name" value=""> 
            <span id="register-name-error"></span>
          </div>
          <div class="group">
            <b>Teléfono</b>
            <input type="tel" id="register-phone" value="" placeholder="Ingrese código de área y número..."> 
            <span id="register-phone-error"></span>
          </div>
          <div class="group">
            <b>Organización</b>
            <input type="text" id="register-organization" value=""> 
            <span id="register-organization-error"></span>
          </div>
          <div class="group">
            <b>Cargo</b>
            <select id="register-occupation" value=""></select>
            <span id="register-occupation-error"></span>
          </div>
          <div class="group">
            <b>Provincia</b>
            <select id="register-idState" value="" onchange="APICRUD.Location.Selector_LoadCities('register-idCity', this.value, '')"></select>
            <span id="register-idState-error"></span>
          </div>
          <div class="group">
            <b>Localidad</b>
            <select id="register-idCity" value=""><option value="0">-- Seleccione primero una provincia --</option></select>
            <span id="register-idCity-error"></span>
          </div>
        </div>

        <div class="terms">
          <input type="checkbox" id="register-terms" />
          <div>He leído y acepto los <a href="https://agrolabores.com/terminos-y-condiciones-de-uso.html" target="_blank">Términos y Condiciones de uso</a>
     y       
    <a
      href="http://agrolabores.com/politicas-de-privacidad.html"
      target="_blank"
      >Políticas de privacidad</a
    >.

          </div>
        </div>

        <div id="register-status" class="mt20"></div>
        <button class="mt20" id="register-btn" onclick="app.userPrivateController.auth.register()">Registrarme</button>
        <hr class="mt20">
        <a href="javascript:app.userPrivateController.auth.showLogin()" class="mt20">Ingresar con mi correo electrónico</a>
    `;
  }

  showRegister() {
    return new ModalController('Registro para nuevos usuarios', this.renderRegister(), 'register');
  }

  showGoogleLogin() {

  }

  showAvatar(_data) {
    if (_data && _data.imageURL) {
      new ModalController('Imagen de perfil', `
          <img class="image-autowidth" src="${(_data.imageURL || '').replace('/thumb', '')}">
      `, 'full');
    } else {
      console.log("No se puede abrir la imagen de perfil");
    }
  }

}
